import css from '../../ComplaintForm/ComplaintForm.module.css'
import { communicationContact } from '../../../choices'
import { InspectFCS } from './pages/inspect'
import {
  complainantPage,
  fileUploadPage,
  narrativePage,
  permissionToDisclosePage,
  previouslyReportedPage,
  previouslyReportedToPage,
  previouslyReportedDatePage,
  reviewPage,
  subjectInfoIndividualPage,
  witnessCorroborationPage,
  witnessPage,
  yesNoPlusInputPage
} from '../../../pages'
import { caseWorkerPage } from './pages/caseWorkerPage'
import { courtOrderPage } from './pages/courtOrderPage'
import { childrenPage } from './pages/childrenPage'
import { childSupportLengthMessage } from '../../../strings/messages'

export const formSchema = saveComplaint => {
  // Define the child support specific pages
  const csPages = [
    yesNoPlusInputPage({
      pageId: 'amount_owed',
      fieldName: 'owe_more_than_minimum_yn',
      label:
        'Does this person currently owe more than $5,000 in child support?',
      className: css.choices,
      labelClassName: css.largeLabel,
      fieldNameOther: 'amount_owed',
      labelOther: 'Please enter the estimated amount ($) of child support owed',
      maxLengthOther: 12,
      otherLengthMessage: childSupportLengthMessage
    }),
    yesNoPlusInputPage({
      pageId: 'subject_location',
      fieldName: 'subject_in_different_location_yn',
      label:
        'Does this person reside in a different state/country than the child?',
      className: css.choices,
      labelClassName: css.largeLabel,
      fieldNameOther: 'subject_location',
      labelOther: 'Please enter the state or country this person resides in'
    }),
    courtOrderPage(),
    caseWorkerPage(),
    childrenPage(),
    previouslyReportedPage({
      gotoPageYes: 'previously_reported_to_page',
      gotoPageNo: 'subject_info_individual_page'
    }),
    previouslyReportedToPage({ choices: communicationContact() }),
    previouslyReportedDatePage(),
    subjectInfoIndividualPage(),
    witnessCorroborationPage({
      gotoPageYes: 'witness_page_0',
      gotoPageNo: 'narrative_page'
    }),
    witnessPage({ maxIndex: 4 }),
    witnessPage({ index: 1, maxIndex: 4 }),
    witnessPage({ index: 2, maxIndex: 4 }),
    witnessPage({ index: 3, maxIndex: 4 }),
    witnessPage({ index: 4, maxIndex: 4 }),
    narrativePage(),
    fileUploadPage(),
    {
      ...permissionToDisclosePage(),
      action: {
        type: 'goto',
        pageId: values => {
          return values.perm_to_disclose == 'Anonymous'
            ? 'review_page'
            : 'complainant_page'
        }
      }
    },
    complainantPage(),
    reviewPage(InspectFCS)
  ]

  return {
    title: 'Federal Child Support Complaint Form',
    onSubmit: formValues => saveComplaint(formValues),
    pages: csPages
  }
}
